<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
      a-form-model-item(label="产品备注" prop="productComments" )
        a-textarea(v-model="model.productComments" placeholder="请输入备注")
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  name: 'CreateAndEdit',
  components: {
    // InspItemCreateAndEdit,
  },
  props: {
    target: Object,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '编辑备注',
      model: {
        productComments: null,
      },
      rules: {
        // productComments: [{ required: true, message: '必填项' }],
      },
      index: 0,
      orignOrder: null,
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  created() {},
  methods: {
    show(product, index) {
      // this.$refs.form.resetFields();
      this.index = index;
      this.orignOrder = _.cloneDeep(this.target);
      // this.productId = this.orignOrder.orderItems[index].productId;
      this.model = {
        ...this.model,
        ...this.orignOrder.orderItems[index],
      };
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        productComments: null,
      };
      this.orignOrder = null;
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        //
        console.log(this.model);
        // this.$emit('change', { ...this.model });
        this.orignOrder.orderItems[this.index] = { ...this.model };
        this.$emit('change', { ...this.orignOrder });
        this.hide();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
